if($('.external-review-swipe-text-slider').length){
  hp.swipers = hp.swipers || {};
  var external_review_swipe_text_slider = 
  {
    initialized: false
  };

  external_review_swipe_text_slider.init = function(){
    var textSliderModuleProps = {
      pagination: {
        el: '.card-module-pagination-textSlider',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.right-arrow-svg-textSlider',
        prevEl: '.left-arrow-svg-textSlider',
      },
      lazy: false,
      slidesPerView: parseInt($("#numberOfPods-text-slider").attr('numberOfPods-text-slider')),/*this is a test code for text slider and will not be present in actual code*/
      spaceBetween: 12,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 12
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        }
      }
    }
    var textSliderModuleMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }
    external_review_swipe_text_slider.instances = hp.swiperInstance('.external-review-swipe-text-slider', textSliderModuleProps, textSliderModuleMethods);
    external_review_swipe_text_slider.initialized = true;
  }//END init

  hp.swipers.external_review_swipe_text_slider=external_review_swipe_text_slider;
}
